// removed by extract-text-webpack-plugin
module.exports = {"cannedReplyList":"cannedReplyList__2ndTXj9B0LjS"};